import React, { useMemo } from 'react';
import { Button, Modal, Table } from '../../../../Components/uielements';
import {
  ModalButtonWrapper,
  ModalWrapper,
  TableCell,
} from '../../../../services/settings/appStyle/global.style';
import { ModalLabel } from '../../UserV2/user.style';
import { IntlMessages } from '../../../../helper/langHelper';

const ViewAssignManagerToPremise = ({ onClose, data }) => {
  const assignManagerColumns = useMemo(
    () => [
      {
        Header: <IntlMessages id="table.col.name" />,
        accessor: 'userName',
        Cell: (cellData) => (
          <TableCell>{`${cellData?.row?.original?.firstName} ${cellData?.row?.original?.lastName}`}</TableCell>
        ),
      },
      {
        Header: <IntlMessages id="table.col.email" />,
        accessor: 'email',
      },
    ],
    []
  );
  return (
    <>
      <Modal
        isOpen={true}
        onClose={onClose}
        title={<IntlMessages id="modal.title.assign.manager.to.premise" />}
      >
        <ModalWrapper>
          {data?.managers?.length > 0 ? (
            <>
              <Table data={data?.managers || []} columns={assignManagerColumns} />
            </>
          ) : (
            <>
              <ModalLabel>
                No manager is currently assigned to premise '{data?.propertyName}'.
              </ModalLabel>
            </>
          )}

          <ModalButtonWrapper>
            <Button onClick={onClose}>
              <IntlMessages id="modal.button.close" />
            </Button>
          </ModalButtonWrapper>
        </ModalWrapper>
      </Modal>
    </>
  );
};

export default ViewAssignManagerToPremise;
